import { render, staticRenderFns } from "./dropdownList.vue?vue&type=template&id=cc72a2d4&scoped=true&"
import script from "./dropdownList.vue?vue&type=script&lang=js&"
export * from "./dropdownList.vue?vue&type=script&lang=js&"
import style0 from "./dropdownList.vue?vue&type=style&index=0&id=cc72a2d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc72a2d4",
  null
  
)

export default component.exports